import { Pipe, PipeTransform } from '@angular/core';
import { Multilingual } from '@digilize/shared/definitions/src';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'getTranslation',
  pure: false,
})
export class GetTranslationPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(multi: Multilingual | undefined, errorCb?: (text: string) => void): string {
    const text = multi[this.translocoService.getActiveLang() as keyof Multilingual];

    if (!text) {
      /*  console.error('Wrong Multilingual object, provided:', multi); */
      return '';
    }
    if (errorCb) {
      errorCb(text);
    }
    return text;
  }
}
